<template>

        <div>

            <b-modal  
      @shown="onShown()"
     :no-close-on-esc="true"
     :no-close-on-backdrop="true"
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="change-pre-reg-subject-from-pre-reg"
      size="xl"
      scrollable
      centered>
        <!-- Modal content-->
       
       
        <div class="row ">
          <div class="col mb-5 ">
                    
                    <div v-for="(modules,i) of Object.keys(theData)">
                    <h3 >{{modules}}</h3>
                    <table class="table table-responsive-lg">
                        
                        <tr v-for="(subjects,j) of theData[modules]" style="cursor:pointer"  @click="changeToSubject(subjects)">

                                <td> {{subjects.subject_code}} | {{ helpers.getLocalizedField(subjects, 'subject')}}</td>

                        </tr>
                        
                    </table>


                    </div>    

          </div>
        </div>






        <div class="row">
          <div class="col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3">
            <button type="button" class="btn btn-light-bold" @click="hideModal()">{{ $t('registration.close') }}</button>
          </div>
        </div>
    </b-modal>


        </div>



</template>
<script>
    export default{

            data(){

                return {

                        theData:[]


                }

            },


            props:['updateData'],

            methods:{

                onShown(){

                        this.$store.dispatch('pre_registration/getProgramSubjects').then(response=>{

                                

                                this.theData=response.data
                        })

                },
                hideModal() {
                this.$bvModal.hide('change-pre-reg-subject-from-pre-reg');
                     this.$emit('closed');

                },

                 
                changeToSubject(subjects){
                  this.$store.dispatch('pre_registration/changePreRegSubject', {
                    subjects:subjects,updateData:this.updateData
                  })
                    .then(response => {                      
                      this.helpers.notifySuccessMessage(response.data.message);
                      setTimeout(() => {
                        window.location.reload(); // Reload the page
                      }, 2000);
                      //this.loadAlreadyRegistered();
                    }).catch(error => {
                      this.helpers.notifyErrorMessage(error);
                  });                   
                    

                }
            }

    }

</script>
